'use strict';

(function () {

  angular
    .module('specsguardApp')
    .factory('TechnicalElementsAPI', TechnicalElementsAPI);

  TechnicalElementsAPI.$inject = ['$resource'];

  function TechnicalElementsAPI ($resource) {
    return $resource('/api/technicalelement/:firstparam/:id',
      { id: '@id' },
      {
        getFull: {
          method: 'GET',
          params: {},
          isArray: true
        },

        getElement: {
          method: 'GET',
          params: {
            firstparam: 'element'
          }
        },

        createModule: {
          method: 'POST',
          params: {
            firstparam: 'module'
          },
          isArray: true
        },
        updateModule: {
          method: 'PUT',
          params: {
            firstparam: 'module'
          },
          isArray: true
        },

        createSubModule: {
          method: 'POST',
          params: {
            firstparam: 'submodule'
          },
          isArray: true
        },
        updateSubModule: {
          method: 'PUT',
          params: {
            firstparam: 'submodule'
          },
          isArray: true
        },

        createElement: {
          method: 'POST',
          params: {
            firstparam: 'element'
          },
          isArray: true
        },
        updateElement: {
          method: 'PUT',
          params: {
            firstparam: 'element'
          },
          isArray: true
        }
      });
  }

})();
